// import $ from 'jquery';

function TalkGateway() {
    this.config = {
        host : "atomy.enomix.co.kr",
        // host : "atomy-dev.enomix.co.kr",
        port : "19010"
    };

    // Gateway 서버와 연결되었을 경우 호출
    this._connectionEstablished = function (talkId) {
        // EX) parent.setIsGatewayAlive(true);
        // Gateway 서버와 연결이 되었을 경우 호출.
        //  - 서버연결 flag 값 true로 변경.
        //  - 신규 메시지 발생 시 이벤트 수신 가능
        //  - 메시지 수신 함수 호출.
        console.log('_connectionEstablished : ', talkId);
    };
    // Gateway 서버와 연결이 끊어졌을 경우 호출
    this._connectionBroken = function (param) {
        console.log('_connectionBroken', param);
        // EX) parent.setIsGatewayAlive(false);

        // Gateway 서버와 연결이 해제 되었을 경우 호출
        //  - 서버연결 flag 값 false로 변경.
        //  - Polling(주기적으로 서버요청) 방식으로 변경하여 메시지 수신
    };

    // 신규 메세지 유무
    this._newMessage = function (talkId) {
        console.log('_newMessage', talkId);
        // store.dispatch('RECEIVE_CHAT_FROM_COUNSELOR', { talkId });
    };

    // 상담원이 Message 입력 중일 경우 호출 됨.
    this._inputStatus = function (talkId, serviceType, status, userType, sender) {
        console.log('[talkId, serviceType, status, userType, sender: ', talkId, serviceType, status, userType, sender, ']');
        // store.dispatch("COUNSELOR_ON_CHAT");
    };

    // 티켓 종료
    this._ticketEnded = function (talkId) {
        console.log('_ticketEnded', _ticketEnded);
        // EX) parent.doNewMessageByGateway(talkId);
        // 상담이 종료된 경우(상담원 또는 시스템 종료) 호출 됨.
        //  - 종료 메시지 수신 호출

        // store.dispatch('RECEIVE_CHAT_FROM_COUNSELOR', { talkId, isExit: true, callback: () => store.commit('UPDATE_MODE', writerType.CHATBOT) });
    };

    this._getConfig = function (param) {
        console.log('_getConfig', param);
        const _self = this;
        // 로그인된 아이디가 없는 경우, 게이트웨이 고객 아이디를 가져온다.
        const customerId = param._customerId;

        $.gateway.initCustomer(_self.config, customerId);
    };
}

export default TalkGateway;